/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_List_SuccessInputs */

const es_tools_dropbox_list_success = /** @type {(inputs: Tools_Dropbox_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta de Dropbox listada`)
};

const en_tools_dropbox_list_success = /** @type {(inputs: Tools_Dropbox_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox folder listed`)
};

/**
* | output |
* | --- |
* | "Dropbox folder listed" |
*
* @param {Tools_Dropbox_List_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_list_success = /** @type {((inputs?: Tools_Dropbox_List_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_List_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_list_success(inputs)
	return en_tools_dropbox_list_success(inputs)
});
export { tools_dropbox_list_success as "tools.dropbox.list_success" }